import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spin, message } from 'antd';
import applicationService from '@/services/applicationService';
import { useAuth } from '@/hooks/useAuth';

const AutoLoginHandler = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { login } = useAuth(); // Use your existing auth hook
    const [status, setStatus] = useState('Verifying credentials...');

    useEffect(() => {
        const autoLoginToken = searchParams.get('auto_login_token');

        if (autoLoginToken) {
            handleAutoLogin(autoLoginToken);
        } else {
            message.warning('No auto-login token found');
            navigate('/login');
        }
    }, [searchParams]);

    const handleAutoLogin = async (token) => {
        const controller = new AbortController();

        // UI safety timeout
        const timeoutId = setTimeout(() => {
            controller.abort();
        }, 9000);

        try {
            setStatus('Authenticating...');

            const response = await applicationService.verifyAutoLoginToken(
                { auto_login_token: token },
                { signal: controller.signal }
            );

            clearTimeout(timeoutId);

            if (!response.success) {
                throw new Error(response.message);
            }

            const {
                accessToken,
                user_id,
                username,
                role,
                ship_id,
                reset_new
            } = response;

            login(accessToken, role, username, ship_id, user_id, reset_new);

            message.success(`Welcome back, ${username}!`);
            navigate('/', { replace: true });

        } catch (error) {
            console.error('❌ Auto-login error:', error);

            const errorMessage = error.response?.data?.message ||
                error.message ||
                'Auto-login failed. Please login manually.';

            message.error(errorMessage);

            setTimeout(() => {
                navigate('/login');
            }, 2000);
        }
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            background: 'linear-gradient(to bottom right, #f5f3ff, #faf5ff, #fff)',
            flexDirection: 'column',
            gap: 20
        }}>
            <Spin size="large" />
            <p style={{
                fontSize: '1.2rem',
                color: '#7c3aed',
                fontWeight: 600
            }}>
                {status}
            </p>
            <p style={{ fontSize: '0.9rem', color: '#6b7280' }}>
                Please wait while we securely log you in...
            </p>
        </div>
    );
};

export default AutoLoginHandler;